import { Link } from '@mui/material';
import '../navigation/NavOptions.scss';

function NavOptions({ options = [] }) {
    let optionsContent = [];
    for (let option of options) {
        optionsContent.push(<Link key={option?.name} className="nav-option" href={option['to']}>
            {option["img"] &&<div className="nav-option-icon"><img src={option["img"]} alt="option-icon" /></div>}
            <div className='option-txt'>{option["name"]}</div>
            <div className='subtitle'>{option["subTitle"]}</div>
        </Link>)
    }

    return (
        <div className="nav-options-wrp">
            {optionsContent}
        </div>
    );
};
export default NavOptions;